var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedStandby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Standby",
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 136,
    viewBox: "0 0 107 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9888",
    "data-name": "Group 9888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9883",
    "data-name": "Group 9883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M95.62,29.38a1.212,1.212,0,0,1-.2-.01H12.51A5.857,5.857,0,0,1,8.14,27.4C2.43,21.34,3.6,2.03,3.65,1.22l2.6.17c-.34,5.27-.31,19.89,3.79,24.25a3.27,3.27,0,0,0,2.47,1.15H95.58l.1.02a2.364,2.364,0,0,0,1.41-.8c1.73-1.72,4.51-7.2,3.65-24.63l2.6-.13c.71,14.42-.87,23.45-4.68,26.85A4.624,4.624,0,0,1,95.62,29.38Z",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9884",
    "data-name": "Group 9884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M101.79,130.32H5.21A5.209,5.209,0,0,1,0,125.13V5.19A5.209,5.209,0,0,1,5.21,0h96.58A5.209,5.209,0,0,1,107,5.19V125.12A5.211,5.211,0,0,1,101.79,130.32ZM5.21,2.6A2.6,2.6,0,0,0,2.6,5.2V125.13a2.61,2.61,0,0,0,2.61,2.6h96.58a2.6,2.6,0,0,0,2.61-2.6V5.19a2.61,2.61,0,0,0-2.61-2.6H5.21Z",
    fill: "#58595b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9885",
    "data-name": "Group 9885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M16.16,136H12.59a3.683,3.683,0,0,1-3.74-3.61v-3.4h2.61v3.4a1.084,1.084,0,0,0,1.13,1.02h3.57a1.084,1.084,0,0,0,1.13-1.02v-3.4H19.9v3.4A3.683,3.683,0,0,1,16.16,136Z",
    fill: "#58595b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9886",
    "data-name": "Group 9886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M96.64,136H93.07a3.683,3.683,0,0,1-3.74-3.61v-3.4h2.61v3.4a1.084,1.084,0,0,0,1.13,1.02h3.57a1.084,1.084,0,0,0,1.13-1.02v-3.4h2.61v3.4A3.689,3.689,0,0,1,96.64,136Z",
    fill: "#58595b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9887",
    "data-name": "Group 9887"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4315",
    "data-name": "Rectangle 4315",
    width: 104.39,
    height: 2.6,
    transform: "translate(1.3 109.13)",
    fill: "#58595b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9889",
    "data-name": "Group 9889"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4316",
    "data-name": "Rectangle 4316",
    width: 25.38,
    height: 18.51,
    transform: "translate(40.38 5.57)",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M66.48,24.8H39.65V4.85H66.48ZM41.1,23.36H65.03V6.29H41.1Z",
    fill: "#6d6e70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedStandby);
export default __webpack_public_path__ + "static/media/led_standby.8377ec8ffd60c365220a3f12cb17392e.svg";
export { ForwardRef as ReactComponent };